const REGISTER_STEPS = [
    { title: 'Búsqueda', text: 'Buscaremos si ya tenemos algunos de tus datos.' },
    { title: 'Rol', text: 'Seleccioná tu rol dentro de la universidad.' },
    { title: 'Datos personales', text: 'Completá tu información personal y verificá tu email.' },
    { title: 'Elegir usuario', text: 'Elegí un nombre de usuario y contraseña para tu cuenta.' },
];

module.exports = { REGISTER_STEPS };
